import React from 'react';
import PropTypes from 'prop-types';

import { SvgIcon } from './SvgIcon';

export const WidgetHeader = ({ title, cssClass, customArrow }) => (
    <header className={`widget-header ${cssClass}`}>
        <div className="widget-header__content">
            <div className="widget-header__title-link">
                <h2 className="widget-header__title">{title}</h2>
                {customArrow ? (
                    customArrow
                ) : (
                    <SvgIcon
                        icon="arrow-right"
                        className="icon video-hub-view-by-match__arrow-icon"
                    />
                )}
            </div>
        </div>
    </header>
);

WidgetHeader.propTypes = {
    title: PropTypes.string,
    cssClass: PropTypes.string,
    customArrow: PropTypes.any
};
